import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/profile/actionTypes';
import { uploadPhoto } from './utils';

export default function* listenUploadPhoto() {
  yield takeEvery(actionTypes.UPLOAD_PHOTO, uploadPhoto);
}
